<div class="d-flex justify-content-center">
	<div style="width: 400px">
		<div class="card card-border-color card-border-color-primary p-shadow-8" *ngIf="eGiftVenue">
			<div class="card-header text-center flex-column">
				<img
					*ngIf="eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + eGiftVenue.venueKey + '/' + eGiftVenue.logoS3Key"
				/>
				<img
					*ngIf="!eGiftVenue.logoS3Key"
					class="w-100"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueKey + '/logo.png'"
				/>
				<div
					class="disclaimer"
					*ngIf="eGiftVenue && eGiftVenue.headerMessage"
					[style.background-color]="eGiftVenue.Venue.ooVenue.styles?.headerBgColor"
					[style.color]="eGiftVenue.Venue.ooVenue.styles?.headerTextColor"
				>
					<div style="max-width: 1200px" class="d-flex h-100 align-items-center mx-auto">
						{{ eGiftVenue.headerMessage }}
					</div>
				</div>
				<div *ngIf="!eGiftVenue.headerMessage">
					<h4>Gift Cards from {{ eGiftVenue.Venue.ooVenue.name }}</h4>
				</div>
				<div *ngIf="!transaction">
					<h4>These aren't the activations you're looking for</h4>
				</div>
				<div *ngIf="transaction && transaction.activated && !eGiftActivationResponse">
					<h4>Looks like this card has already been activated.</h4>
					If you think this is an error, you can reach out to {{ ooVenue.name }} at {{ app.references.phoneNumberToDisplayFormat(ooVenue.phone) }}
				</div>
				<div *ngIf="transaction && !transaction.activated && !eGiftActivationResponse" class="d-flex flex-column">
					<div class="m-2 mt-4">You're activating a {{ transaction.value | currency }} gift card for {{ ooVenue.name }}</div>
					<div class="m-2">Please fill out the form below to activate your card.</div>
					<form #activationForm="ngForm">
						<input
							required
							pInputText
							type="text"
							placeholder="Your first Name"
							name="firstName"
							[(ngModel)]="transaction.recipientFirstName"
							class="w-100 m-2"
						/>
						<input
							required
							pInputText
							type="text"
							placeholder="Your last Name"
							name="lastName"
							[(ngModel)]="transaction.recipientLastName"
							class="w-100 m-2"
						/>
						<input
							required
							pInputText
							type="email"
							placeholder="Your email address"
							name="email"
							[(ngModel)]="transaction.recipientEmail"
							class="w-100 m-2"
						/>
						<p-button
							pRipple
							styleClass="p-button-raised p-button-success m-2 w-100"
							label="Activate My Card"
							(click)="activateTransaction()"
						></p-button>
					</form>
				</div>
				<div *ngIf="eGiftActivationResponse" class="d-flex flex-column">
					<div class="m-2">
						<h4>Congratulations, your gift card has been successfully activated.</h4>
					</div>

					<div class="m-2">
						You'll be receiving an email shortly with your QR Code and card number. Present the QR code or card number at {{ ooVenue.name }} and
						enjoy your selections!
					</div>
					<div class="mx-2 mt-2">
						<img
							*ngIf="eGiftActivationResponse.transactionGuid"
							src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/{{ ooVenue.venueKey }}/qr/{{
								eGiftActivationResponse.transactionGuid
							}}.png"
							width="75%"
							height="auto"
							alt="QR Code of card"
						/>
					</div>
					<div class="mx-2 mb-2">
						{{ eGiftActivationResponse.cardNumber }}
					</div>
					<div class="d-flex justify-content-center" *ngIf="appleWalletPreferences">
						<a [routerLink]="['../../wallet/' + transaction.key]" target="_blank">
							<img
								src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Add_to_Apple_Wallet_rgb_US-UK.svg"
								alt="Add to Apple Wallet"
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
